import { render, staticRenderFns } from "./ShipmentInfo.vue?vue&type=template&id=3a14b4ca&scoped=true"
import script from "./ShipmentInfo.vue?vue&type=script&lang=js"
export * from "./ShipmentInfo.vue?vue&type=script&lang=js"
import style0 from "./ShipmentInfo.vue?vue&type=style&index=0&id=3a14b4ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a14b4ca",
  null
  
)

export default component.exports